import SectionLabel from "../../app/universalComponents/SectionLabel";
import Button from "../../app/universalComponents/Button";

export default function ScanResult({ result, onContinue }) {
  return (
    <div className="flex h-[100dvh] flex-col items-center justify-center text-white">
      <div
        className={`flex-1 flex flex-col w-full items-center justify-end pb-8 ${
          result.is_valid ? "bg-green-600" : "bg-red-600"
        }`}
      >
        <h1 className="text-9xl pb-8">{result.is_valid ? "✓" : "✗"}</h1>
        <h1 className="text-5xl font-semibold">
          {result.is_valid ? "Checked In" : "Invalid Ticket"}
        </h1>

        <p className="text-xl pt-4">{result.message}</p>
      </div>

      {result.message !== "Ticket not found" ? (
        <div className="flex-1 flex flex-col justify-between w-full p-4">
          <section className="pt-2">
            <SectionLabel>Ticket Details</SectionLabel>

            <div className="rounded-sm border border-gray-200 p-4 text-black">
              <p className="text-xl font-medium">{result.name}</p>

              <p className="mt-2 text-base">{result.ticket_type}</p>
            </div>
          </section>
          <Button className="text-xl py-4" onClick={onContinue}>
            Scan Next Ticket
          </Button>
        </div>
      ) : (
        <div className="flex flex-1 w-full flex-col p-4">
          <div className="flex flex-1 items-center justify-center">
            <p className="max-w-sm text-center text-sm text-gray-500">
              We couldn't find this ticket. The attendee might not be showing
              the correct QR code. Direct them to the organiser for assistance.
            </p>
          </div>

          <Button className="text-xl py-4" onClick={onContinue}>
            Scan Next Ticket
          </Button>
        </div>
      )}
    </div>
  );
}
